import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useMyPermissions } from "@/features/permissions/hooks/usePermissionsQueries";
import { delegationsService } from "../services/delegationsService";

export const delegationsKeys = {
  overview: () => ["delegations", "overview"] as const,
};

/**
 * `delegations:manage` is SUPER_ADMIN-only by baseline, so this is false for almost
 * everyone and the sidebar entry is filtered on the same key.
 *
 * ⚠️ IT IS AN AFFORDANCE, NOT A BOUNDARY. Every endpoint behind this page checks the
 * same permission server-side in `requirePermission`; hiding the page is only so
 * nobody is offered a screen that would refuse them.
 */
export function useCanManageDelegations(): boolean {
  const { data } = useMyPermissions();
  return (data?.permissions ?? []).includes("delegations:manage");
}

export function useDelegationsOverview(enabled = true) {
  return useQuery({
    queryKey: delegationsKeys.overview(),
    queryFn: () => delegationsService.overview(),
    enabled,
  });
}

export function useActivateDelegationVersion() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ slug, version }: { slug: string; version: number }) =>
      delegationsService.activate(slug, version),
    onSuccess: () => qc.invalidateQueries({ queryKey: delegationsKeys.overview() }),
  });
}
